import { Alert, Button, Card, Checkbox, Form, Input, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import sspApi from 'src/component/app/ssp/SspApi'
import { billingTypeName } from 'src/component/app/ssp/SspCreate'
import { uuidV4 } from 'src/util/Util'
import { SspBean } from '../../../api/api'
import { formDataLoader, FormDataType } from '../../../util/FormDataLoader'

const FormItem = Form.Item
const Option = Select.Option

const formInfoItems: FormDataType[] = [
    FormDataType.Countries
]

const SspEdit = () => {

    const [info, setInfo] = useState({
        countries: [],
    })
    const navigateTo = useNavigate()
    const { id } = useParams<{ id: string }>()
    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await sspApi.edit(id, values)
            navigateTo('/ssp')
        } catch (e) {
            setError(e.error)
        }
    }

    const loadData = async () => {
        try {
            const response: any = await sspApi.view(id)
            form.setFieldsValue(response.data)

            const formInfo = await formDataLoader(...formInfoItems)
            setInfo(formInfo as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [id])

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card title="SSP" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input placeholder="Name" />
            </FormItem>
            <FormItem
                required
                name="endpoint"
                label="Endpoint"
            >
                <Input placeholder="Endpoint" />
            </FormItem>
            <FormItem
                required
                name="sspType"
                label="SSP Type"
            >
                <Select placeholder="Select SSP Type">
                    {Object.values(SspBean.SspTypeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                required
                name="billingType"
                label="Billing Type"
            >
                <Select placeholder="Select Billing Type">
                    {Object.values(SspBean.BillingTypeEnum).map(type => <Option key={type} value={type}>{billingTypeName(type as string)}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="apiKey"
                label="API key"
            >
                <Input placeholder="Generate API key" addonAfter={<Button size="small" type="text" onClick={() => form.setFieldValue('apiKey', uuidV4())}>Generate</Button>} />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue="true"
                required
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="consentValidation"
                label="TCF check"
                valuePropName="checked"
                required
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="linkByDefault"
                label="Link by Default"
                valuePropName="checked"
                required
            >
                <Checkbox />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Save</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/ssp')}>Cancel</Button>
        </div>
    </Form>
}

export default SspEdit


// WEBPACK FOOTER //
// ./src/component/app/ssp/SspEdit.tsx